module.exports = __webpack_public_path__ + "static/media/assistant_icon.02dc4608.svg";